<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model"
                   :title="model.uuid ? $t(`Update Campaign`) : $t(`Create New Campaign`)"
                   @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading"
                   :content-in-form="false" scrollable>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="title"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="schedule_date" type="date"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="schedule_time" type="time"/>
        </div>
        <div class="col-md-12 mb-3 ckeditor-placeholder">
          <input-widget :model="model" attribute="text" type="ckeditor"/>
          <template-variables v-if="campaignTemplate" :variables="campaignTemplate.variables"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../../core/components/artisio-modal/ArtisioModal";
  import CampaignModel from "@/modules/marketing/audience/campaign/Campaign.model";
  import TemplateVariables from "@/modules/setup/templates/TemplateVariables";

  const {mapState, mapActions} = createNamespacedHelpers('marketing/audience');
  const {mapState: templatesMapState} = createNamespacedHelpers('setup/templates');

  export default {
    name: "CampaignModal",
    components: {
      TemplateVariables,
      InputWidget, ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new CampaignModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.view.campaignModal,
        editObject: state => state.view.campaignModal.object
      }),
      ...templatesMapState({
        campaignTemplate: state => state.templates.rows.find(t => t.key === 'audience_campaign')
      })
    },
    watch: {
      editObject() {
        if ((this.editObject && this.editObject.uuid) || this.editObject.audience_uuid) {
          this.model = new CampaignModel(this.editObject);
          if (this.campaignTemplate && !this.model.uuid) {
            this.model.text = this.campaignTemplate.body;
          }
        }
      },
    },
    methods: {
      ...mapActions(['hideCampaignModal', 'createCampaign', 'updateCampaign']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new CampaignModel();
        this.hideCampaignModal();
      },
      async onSubmit() {
        let response;
        this.loading = true;

        if (!this.model.uuid) {
          response = await this.createCampaign(this.model);
        } else {
          response = await this.updateCampaign(this.model);
        }

        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideCampaignModal();
          if (!this.model.uuid) {
            this.$toast('success', this.$t('Campaign was successfully created'));
          } else {
            this.$toast('success', this.$t('Campaign was successfully updated'));
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .ckeditor-placeholder {
    /deep/ .form-group {
      margin-bottom: 0;
    }

    /deep/ .ck-editor__editable_inline {
      height: 5em !important;
    }
  }
</style>
